<template>
  <div ref="entra_form">
    <b-overlay
      ref="overlay_index"
      :show="showLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card>
        <b-row>
          <b-col
            sm="1"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
          </b-col>

          <b-col md="3">
            <b-form-group label="Establecimiento Origen">
              <v-select
                :options="stores"
                label="name"
                v-model="form.storeOrigin"
                :reduce="(store) => store.id"
                placeholder="Seleccione un establecimiento"
                @input="loadAutoparts"
              />
            </b-form-group>
          </b-col>

          <!-- Cliente -->
          <b-col md="2">
            <b-form-group label="Documento">
              <b-form-input
                v-model="form.clientDni"
                placeholder="Ingrese DNI o RUC"
              />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Nombre">
              <b-form-input
                v-model="form.clientName"
                placeholder="Ingrese Nombre"
              />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Tipo de Moneda">
              <b-form-select v-model="form.currencyType">
                <b-form-select-option value="Sol">Sol</b-form-select-option>
                <b-form-select-option value="Dólar">Dólar</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col
            md="2"
            class="d-flex justify-content-center align-items-center mt-1"
          >
            <b-button
              :disabled="tableItems.length === 0"
              variant="primary"
              @click="saveQuote"
            >
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="mt-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Autoparte">
              <v-select
                :options="autoparts"
                label="label"
                v-model="newItem.autopart"
                :reduce="(autopart) => autopart"
                placeholder="Seleccione una autoparte"
                :filterable="true"
                :filter-by="customFilter"
                @input="updateQtyAvailable"
              />
            </b-form-group>
          </b-col>

          <!--<b-col md="2">
            <b-form-group label="Cantidad Disponible">
              <b-form-input type="number" v-model="newItem.qtyAvailable" readonly />
            </b-form-group>
          </b-col>-->

          <b-col md="2">
            <b-form-group label="Cantidad Solicitada">
              <b-form-input
                v-model="newItem.requiredQty"
                type="number"
                placeholder="Ingrese cantidad"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Tipos de precio">
              <v-select
                :options="priceOptions"
                label="name"
                v-model="newItem.selectedPrice"
                :reduce="(price) => price.value"
                placeholder="Seleccione un precio"
                @input="updatePrice"
              />
            </b-form-group>
          </b-col>

          <b-form-group label="Precio seleccionado">
            <b-form-input
              v-model.number="newItem.unitPrice"
              :class="{ 'is-invalid': newItem.unitPrice < newItem.minPrice }"
              type="number"
              placeholder="Ingrese precio"
              @keydown="preventInvalidPrice"
              @blur="enforceMinPrice"
            />
            <b-form-invalid-feedback
              v-if="newItem.unitPrice < newItem.minPrice"
            >
              El precio no puede ser menor al mínimo permitido ({{
                newItem.minPrice
              }}).
            </b-form-invalid-feedback>
          </b-form-group>

          <b-col md="1" class="d-flex align-items-center mt-1 p-0 ml-1">
            <b-button variant="primary" @click="addRow">Agregar</b-button>
          </b-col>
        </b-row>

        <b-card v-if="tableItems.length > 0" no-body>
          <b-table
            :items="tableItems"
            :fields="fields"
            responsive
            hover
            class="border border-2 rounded mt-2"
          >
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="danger"
                @click="removeRow(data.index)"
              >
                Eliminar
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-card>

      <b-card class="mt-1">
        <h4 class="font-weight-bold">Resumen de Costos</h4>
        <b-table
          small
          :items="calculatedItems"
          :fields="summary"
          responsive
          hover
          class="border border-2 rounded mt-2"
          head-variant="light"
          style="font-size: 1.1rem"
        >
          <template #cell(unitPrice)="data">
            {{ currencySymbol }} {{ data.item.unitPrice }}
          </template>
          <template #cell(cost)="data">
            {{ currencySymbol }} {{ data.item.cost }}
          </template>
        </b-table>
        <b-row class="mt-3">
          <b-col class="text-right font-weight-bold" style="font-size: 1.25rem">
            Total:
          </b-col>
          <b-col
            class="text-left text-primary font-weight-bold"
            style="font-size: 1.5rem"
          >
            {{ currencySymbol }} {{ totalCost.toFixed(2) }}
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import InventoryService from "@/services/InventoryService";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import QuoteService from "@/services/QuoteService";
import UserService from "@/services/UserService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      showLoading: false,
      userEstablishments: [],
      datosUser: null,
      form: {
        storeOrigin: null,
        clientDni: "",
        clientName: "",
        currencyType: "Sol",
      },
      clients: [],
      newItem: {
        autopart: null,
        qtyAvailable: 0,
        requiredQty: null,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0,
      },
      stores: [],
      categories: [],
      autoparts: [],
      tableItems: [],
      priceOptions: [
        { name: "Precio Tienda", value: "retailPrice" },
        { name: "Precio x Mayor", value: "wholesalePrice" },
        { name: "Precio Cliente Final", value: "clientPrice" },
      ],
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: false },
        { key: "autopart.AutopartBrand.name", label: "Marca", sortable: false },
        { key: "autopart.label", label: "Autoparte" },
        { key: "qtyAvailable", label: "Cantidad Disponible" },
        { key: "requiredQty", label: "Cantidad Solicitada" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "actions", label: "Acciones" },
      ],
      summary: [
        { key: "uniqueCode", label: "Código Único" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "unitPrice", label: "Precio Unitario" },
        { key: "cost", label: "Costo (Cantidad x Precio)" },
      ],
    };
  },
  components: {
    vSelect,
  },
  computed: {
    currencySymbol() {
      return this.form.currencyType === "Dólar" ? "$" : "S/";
    },

    calculatedItems() {
      return this.tableItems.map((item) => ({
        uniqueCode: item.autopart.uniqueCode,
        description: item.autopart.label,
        quantity: item.requiredQty,
        unitPrice: item.unitPrice.toFixed(2),
        cost: (item.requiredQty * item.unitPrice).toFixed(2),
      }));
    },

    totalCost() {
      return this.tableItems.reduce((sum, item) => {
        return sum + item.requiredQty * item.unitPrice;
      }, 0);
    },
  },
  watch: {
    "newItem.unitPrice"(value) {
      if (value < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },

    "form.storeOrigin": function (newValue) {
      this.newItem.autopart = null;
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;
      this.newItem.selectedPrice = null;
      this.newItem.unitPrice = 0;

      this.tableItems = [];

      if (newValue) {
        this.loadAutoparts();
      } else {
        this.categories = [];
      }
    },

    "newItem.autopart": function (newValue) {
      this.newItem.qtyAvailable = null;
      this.newItem.requiredQty = null;
      this.newItem.selectedPrice = null;
      this.newItem.unitPrice = 0;

      if (newValue) {
        this.updateQtyAvailable();
      }
    },

    "newItem.selectedPrice": function (newValue) {
      if (!newValue || !this.newItem.autopart) {
        this.newItem.unitPrice = 0;
        return;
      }
      const selectedPrice = parseFloat(this.newItem.autopart[newValue]);
      this.newItem.unitPrice = selectedPrice || 0;
      this.newItem.minPrice = selectedPrice || 0;
    },
  },
  mounted() {
    this.loadStores();
    this.loadClients();
    this.datosUser = JSON.parse(localStorage.getItem("userData"));
    this.userEstablishments = this.datosUser?.data?.userEstablishments || [];
    this.userEstablishments = this.userEstablishments.map(
      (establishment) => establishment.id
    );
    console.log("my stablishments", this.userEstablishments);
  },
  methods: {
    updateQtyAvailable() {
      if (!this.newItem.autopart) {
        this.newItem.qtyAvailable = null;
        return;
      }
      this.newItem.qtyAvailable = this.newItem.autopart.qtyAvailable;
    },

    preventInvalidPrice(event) {
      const newValue = parseFloat(event.target.value + event.key);
      if (newValue < this.newItem.minPrice && !isNaN(newValue)) {
        event.preventDefault();
      }
    },

    enforceMinPrice() {
      if (this.newItem.unitPrice < this.newItem.minPrice) {
        this.newItem.unitPrice = this.newItem.minPrice;
      }
    },

    customFilter(option, label, search) {
      if (!search) return true;
      const normalizedLabel = label.toLowerCase();
      const normalizedSearch = search.toLowerCase().split(" ");
      return normalizedSearch.every((word) => normalizedLabel.includes(word));
    },

    async loadClients() {
      const response = await UserService.getUsers("", this.$store);
      this.clients = response.data.rows
        .filter((user) => user.role.name === "Cliente")
        .map((client) => ({
          id: client.id,
          fullname: client.fullname,
          document: client.document,
          label: `${client.document} - ${client.fullname}`,
        }));
    },

    async loadStores() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const userEstablishments = userData?.data?.userEstablishments || [];

      this.stores = userEstablishments.map((est) => ({
        id: est.id,
        name: est.name,
      }));

      console.log("ESTABLECIMIENTOS:", this.stores);
    },

    updatePrice() {
      if (!this.newItem.autopart || !this.newItem.selectedPrice) {
        this.newItem.unitPrice = 0;
        this.newItem.minPrice = 0;
        return;
      }

      const selectedPrice = parseFloat(
        this.newItem.autopart[this.newItem.selectedPrice]
      );
      this.newItem.unitPrice = selectedPrice;
      this.newItem.minPrice = selectedPrice;
    },

    async loadAutoparts() {
      if (!this.form.storeOrigin) return;
      const response = await InventoryService.getStockxStore(
        this.form.storeOrigin,
        this.$store
      );
      this.autoparts = response.data.map((item) => ({
        id: item.autopart.id,
        label: `${item.autopart.AutopartBrand.name} - ${item.autopart.originalCode} - ${item.autopart.description}`,
        AutopartBrand: { name: item.autopart.AutopartBrand.name },
        uniqueCode: item.autopart.uniqueCode,
        qtyAvailable: item.qtyAvailable,
        retailPrice: item.autopart.retailPrice,
        wholesalePrice: item.autopart.wholesalePrice,
        clientPrice: item.autopart.clientPrice,
      }));
    },

    addRow() {
      if (
        !this.newItem.autopart ||
        !this.newItem.requiredQty ||
        !this.newItem.selectedPrice ||
        this.newItem.unitPrice === 0
      ) {
        this.$swal(
          "Error",
          "Complete todos los campos antes de agregar una autoparte.",
          "error"
        );
        return;
      }

      if (this.newItem.unitPrice < this.newItem.minPrice) {
        console.log(
          "Precio inválido detectado:",
          this.newItem.unitPrice,
          this.newItem.minPrice
        );
        this.$swal(
          "Error",
          `El precio ingresado (${this.newItem.unitPrice}) no puede ser menor al mínimo permitido (${this.newItem.minPrice}).`,
          "error"
        );
        return;
      }

      if (
        this.tableItems.find(
          (item) => item.autopart.id === this.newItem.autopart.id
        )
      ) {
        this.$swal("Error", "La autoparte ya está en la lista.", "error");
        return;
      }

      this.tableItems.push({
        autopart: {
          id: this.newItem.autopart.id,
          uniqueCode: this.newItem.autopart.uniqueCode,
          label: this.newItem.autopart.label,
          AutopartBrand: {
            name: this.newItem.autopart.AutopartBrand.name,
          },
        },
        qtyAvailable: this.newItem.qtyAvailable,
        requiredQty: this.newItem.requiredQty,
        unitPrice: this.newItem.unitPrice,
      });

      this.newItem = {
        autopart: null,
        qtyAvailable: 0,
        requiredQty: null,
        unitPrice: 0,
        selectedPrice: null,
        minPrice: 0,
      };
    },

    removeRow(index) {
      this.tableItems.splice(index, 1);
    },
    async saveQuote() {
  if (!this.form.storeOrigin || !this.form.clientDni || !this.form.clientName) {
    this.$swal("Error", "Complete todos los campos antes de guardar la proforma.", "error");
    return;
  }

  if (this.tableItems.length === 0) {
    this.$swal("Error", "Agregue al menos una autoparte a la proforma.", "error");
    return;
  }

  const items = this.tableItems.map((item) => ({
    autopartId: item.autopart.id,
    qty: parseInt(item.requiredQty),
    unitPrice: parseFloat(item.unitPrice),
  }));

  const response = await UserService.getUsers("", this.$store);
  const users = response.data.rows;
  const extraPasswords = users
    .map((user) => user.extraPassword)
    .filter((password) => password !== null);

  if (extraPasswords.length === 0) {
    this.$swal("Error", "No hay contraseñas extras registradas.", "error");
    return;
  }

  const { value: inputPassword } = await this.$swal({
    title: "Ingrese la contraseña extra",
    input: "password",
    inputPlaceholder: "Ingrese la contraseña extra",
    showCancelButton: true,
    confirmButtonText: "Validar",
    cancelButtonText: "Cancelar",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-secondary ml-1",
    },
    buttonsStyling: false,
    inputValidator: (value) => {
      if (!value) {
        return "Debe ingresar una contraseña.";
      }
      if (!extraPasswords.includes(value)) {
        return "Contraseña incorrecta. Intente nuevamente.";
      }
    },
  });

  if (!inputPassword) {
    return;
  }

  const matchingUser = users.find(user => user.extraPassword === inputPassword);

  if (!matchingUser) {
    this.$swal("Error", "Contraseña no válida.", "error");
    return;
  }

  const data = {
    establishmentOriginId: this.form.storeOrigin,
    clientDni: this.form.clientDni,
    clientName: this.form.clientName,
    registerById: matchingUser.id, 
    autoparts: items,
    state: "Cotización",
    currencyType: this.form.currencyType,
  };

  console.log("data", data);

  try {
    this.showLoading = true;
    const response = await QuoteService.saveQuote(data, this.$store);

    if (response && response.statusCode === 200 && response.data?.headerCreated) {
      const correlativo = response.data.headerCreated.correlative;

      console.log("Respuesta del backend:", response);

      await this.$swal({
        title: "Éxito",
        text: `La proforma ha sido guardada correctamente.\n Su correlativo es: ${correlativo}`,
        icon: "success",
        confirmButtonText: "Aceptar",
      });

      this.$router.push("/proforma");

      this.form = {
        storeOrigin: null,
        documentClient: "",
        fullnameClient: "",
      };
      this.tableItems = [];
    } else {
      this.$swal("Error", "Ocurrió un problema al guardar la proforma.", "error");
    }
  } catch (error) {
    console.error("Error al guardar la proforma:", error);
    this.$swal("Error", "Ocurrió un problema al guardar la proforma.", "error");
  } finally {
    this.showLoading = false;
  }
},

  },
};
</script>
